var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectADate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 104,
    viewBox: "0 0 55 104",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#B4321E",
    width: 55,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 5,
    y: 5,
    width: 45,
    height: 94,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h25v3a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3V3z",
    fill: "#B4321E"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 20.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 24,
    y: 4,
    width: 12,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D4382A",
    x: 13,
    y: 19,
    width: 29,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B4321E",
    x: 13,
    y: 43,
    width: 29,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M22 53.162 25.838 57l8-8"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D4382A",
    x: 13,
    y: 67,
    width: 29,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M22 77.162 25.838 81l8-8M21.58 29.43l3.84 3.838 8-8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectADate);
export default __webpack_public_path__ + "static/media/select-a-date.2ce9f44cecc735fa7af1c283e1c94e5d.svg";
export { ForwardRef as ReactComponent };